<template>
  <div class="container">
    <section>
      <div class="layout">
        <div class="child">
          <div class="pure-g">
            <div class="pure-u-1">
              <div class="font-secondary">
                <h2>{{ inProgressStudyName }}</h2>
              </div>
            </div>
          </div>
          <div class="pure-g">
            <div class="pure-u-1">
              <div>
                <h3>
                  For your study, please choose {{ questionsAmount }} questions which tell a story.
                </h3>
              </div>
            </div>
          </div>
          <IdeaCoach :type="questionType" @submit="ideaCoachSubmitted" @idea="ideaCoachLaunched" />
          <div>
            <form
              class="pure-form pure-form-stacked"
              @submit.prevent="handleSubmit"
              novalidate
              :ref="formRefName"
            >
              <fieldset>
                <div v-for="(question, idx) in formModel.questions" :key="idx">
                  <div class="pure-g">
                    <div class="pure-u-1">
                      <span class="question-title" :class="question.getClassObj()"
                        >{{ question.getPlaceholderText() }}*</span
                      >
                    </div>
                    <div class="pure-u-1">
                      <input type="text" :ref="questionsRefName" v-model="question.text" />
                    </div>
                  </div>
                </div>
                <div v-if="showAreQuestionsUniqueValidationUI">
                  <div class="pdng-1 top">
                    <div class="invalid">
                      <small>Questions should be unique.</small>
                    </div>
                  </div>
                </div>

                <button type="submit" class="hidden-submit"></button>
              </fieldset>
              <BigStudyNavigation @touched="onTouched"></BigStudyNavigation>
            </form>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  GET_IN_PROGRESS_STUDY_NAME,
  GET_IN_PROGRESS_STUDY_QUESTIONS,
  SET_IN_PROGRESS_STUDY_QUESTIONS_TEXT,
  GET_NEXT_STUDY_STEP_ROUTE,
  UPDATE_STUDY,
  GET_IN_PROGRESS_STUDY_QUESTIONS_AMOUNT,
  CSS_CLASS_NAME_INVALID,
  IDEA_COACH_TYPE,
} from "../../services/constants";
import IdeaCoach from "../../components/idea-coach/IdeaCoach";

export default {
  name: "Questions",
  data() {
    return {
      formModel: null,
      submitTouched: false,
    };
  },
  components: { IdeaCoach },
  computed: {
    ...mapGetters([
      GET_NEXT_STUDY_STEP_ROUTE,
      GET_IN_PROGRESS_STUDY_QUESTIONS,
      GET_IN_PROGRESS_STUDY_NAME,
      GET_IN_PROGRESS_STUDY_QUESTIONS_AMOUNT,
    ]),
    questionsAmount() {
      return this[GET_IN_PROGRESS_STUDY_QUESTIONS_AMOUNT];
    },
    inProgressStudyName() {
      return this[GET_IN_PROGRESS_STUDY_NAME];
    },
    formRefName() {
      return "formRef";
    },
    areQuestionsValid() {
      return this.formModel.questions.map((question) => {
        return question.text.length > 0;
      });
    },
    areQuestionsUnique() {
      const uniqueQuestions = [];
      this.formModel.questions.forEach((question) => {
        if (uniqueQuestions.indexOf(question.text) < 0) {
          uniqueQuestions.push(question.text);
        }
      });
      return uniqueQuestions.length === this.formModel.questions.length;
    },
    showAreQuestionsUniqueValidationUI() {
      return !this.areQuestionsUnique && this.submitTouched;
    },
    questionsValidUI() {
      return this.areQuestionsValid.map((isValid) => {
        return !isValid && this.submitTouched;
      });
    },
    questionsValidationClassObjs() {
      return this.questionsValidUI.map((isInvalid) => {
        return {
          [CSS_CLASS_NAME_INVALID]: isInvalid,
        };
      });
    },
    isFormModelValid() {
      return (
        this.areQuestionsValid.every((isValid) => {
          return isValid;
        }) && this.areQuestionsUnique
      );
    },
    questionsRefName() {
      return "questionsRef";
    },
    questionType() {
      return IDEA_COACH_TYPE.question;
    },
  },
  methods: {
    handleSubmit() {
      if (this.isFormModelValid) {
        const questionsOnlyText = this.formModel.questions.map((question) => {
          return {
            text: question.text,
          };
        });
        this.$store.commit(SET_IN_PROGRESS_STUDY_QUESTIONS_TEXT, questionsOnlyText);
        this.$store.dispatch(UPDATE_STUDY).then(() => {
          this.$router.push(this[GET_NEXT_STUDY_STEP_ROUTE]);
        });
      }
    },
    resetFormModel() {
      const self = this;
      this.formModel = Object.assign(
        {},
        {
          questions: this[GET_IN_PROGRESS_STUDY_QUESTIONS].map((question, i) => {
            return {
              text: question.text,
              getPlaceholderText() {
                return question.name;
              },
              getClassObj() {
                return self.questionsValidationClassObjs[i];
              },
            };
          }),
        }
      );
    },
    focusFirstQuestion() {
      //$nextTick only needed for Chrome, firefox works without it
      this.$nextTick(() => {
        if (
          this.$refs[this.questionsRefName] &&
          this.$refs[this.questionsRefName].length &&
          this.$refs[this.questionsRefName].length > 0
        ) {
          this.$refs[this.questionsRefName][0].focus();
        }
      });
    },
    onTouched() {
      this.submitTouched = true;
    },
    ideaCoachLaunched() {
      const questionsOnlyText = this.formModel.questions.map((question) => {
        return {
          text: question.text,
        };
      });
      this.$store.commit(SET_IN_PROGRESS_STUDY_QUESTIONS_TEXT, questionsOnlyText);
    },
    ideaCoachSubmitted() {
      this.resetFormModel();
    },
  },
  created() {
    this.resetFormModel();
  },
  mounted() {
    this.focusFirstQuestion();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../../scss/main";

.container {
  height: 100%;
}

section {
  height: 100%;
}

.layout {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100%;
}

.child {
  width: 100%;
  max-width: 500px;
  margin: 1em;
}

h2,
h3 {
  text-align: center;
}

h2 {
  color: $red-2;
}

h3 {
  color: $cyan-blue-3;
}

.pure-form input[type="text"] {
  box-shadow: none;
  width: 100%;
  color: $cyan-blue-3;
  border-color: $cyan-blue-3;

  &:focus {
    border-color: $cyan-blue-1;
  }
  &:placeholder-shown {
    color: $gray-3;
  }
  &:-ms-input-placeholder {
    color: $gray-3;
  }
}

.question-title {
  font-size: 0.83em;
  font-weight: bold;
  color: $cyan-blue-3;
  &.invalid {
    color: $red-2;
  }
}

.invalid {
  color: $red-2;
}
</style>
